//wait for element function.
function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        // If you get "parameter 1 is not of type 'Node'" error, see https://stackoverflow.com/a/77855838/492336
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}

waitForElm('.acc-fragrance-variants').then((elm) => {
    //locking header.
    const optionheader = $('.acc-custom-selector__select--dropdown-options-header');
    const firstoptionheader = $('.acc-custom-selector__select--dropdown-options .acc-custom-selector__select--dropdown-options-header:nth-of-type(1)');
    optionheader.each(function () {
        this.style.setProperty('display', 'flex', 'important');
    });

    optionheader.on('click', (e) => {
        e.preventDefault(); e.stopPropagation();
    });

    var searchhtml = `
<input type="text" id="bundle-search-box" class="bundle-search-box" placeholder="Search here">
<img style="/* transform: translateY(6px); */flex: 0;width: 22px;position: absolute;top: 23px;left: 15px;" src="https://cdn.shopify.com/s/files/1/0288/6156/2924/files/alt-search-bundle.png?v=1708774176" alt="Icon">
<span class="clear-button" onclick="clearDropdownSearch(this)">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg><style>       
                .clear-button {
            position: absolute;
            top: 20px;
            right: 40px;
            cursor: pointer;
            display: none !important; /* initial*/
            width: auto !important;
        }

        .clear-button svg {
            width: 28px;
            height: 28px;
            fill: #555 !important;
            color: #555 !important;
        }</style>
            </span>
<style>
        #bundle-search-box {
            width: 100% !important;
        }

        /* TO MOVE TO CSS FILE */
          <style>
/* SEARCH BORDER VL:  1px solid #9e9e9e */

@media only screen and (min-width: 481px) {

    /* hiding name and inspired on Desktop. */
    .acc-custom-selector__select--dropdown-options-header span {
        display: none !important;

    }

    .acc-custom-selector__select--dropdown-options-header span.search-box {
        display: block !important;
    }

}

@media only screen and (max-width: 480px) {
    .bundle-search-box {
        margin-bottom: 12px;
        flex-basis: 100%;
        width: 100%;
    }

    .clear-button {
        flex: 0;
    }

    .acc-custom-selector__select--dropdown-options-header {
        flex-wrap: wrap;
    }

    /* may need extra logic for max height! */
    .acc-custom-selector__select--dropdown-options.show-dropdown {
        max-height: 80vh !important;
        top: 60% !important;
    }

}

.bundle-search-box {
    flex-basis: 100%;
    width: 100%;
    padding-left: 30px;

}

.clear-button {
    flex: 0;
}

.acc-custom-selector__select--dropdown-options-header {
    flex-wrap: wrap;
}

  </style>
`;

    // search glass img html to add:
    // <img style="/* transform: translateY(6px); */flex: 0;width: 22px;position: absolute;top: 23px;left: 15px;" src="https://cdn.shopify.com/s/files/1/0288/6156/2924/files/alt-search-bundle.png?v=1708774176" alt="Icon">

    firstoptionheader.prepend(searchhtml);

    // setting mobile to have 80vh.
    /**/ let isMobile = window.matchMedia("only screen and (max-width: 480px)").matches;
    if (isMobile == true) {
        const mobileDropdown = document.querySelectorAll('.acc-custom-selector__select--dropdown-options');
        mobileDropdown.forEach(element => {
            // element.style.setProperty("max-height", "80vh", "important");
            // element.style.setProperty("top", "60%", "important");
        });
    }

    // proceeding w/ logic.
    const dropdownContainers = document.querySelectorAll('.acc-custom-selector__select--dropdown-options');

    dropdownContainers.forEach(container => {
        const searchBox = container.querySelector('.bundle-search-box');
        const dropdownOptions = container.querySelector('.acc-custom-selector__select--dropdown-options-body');
        const originalOptions = Array.from(dropdownOptions.children);

        searchBox.addEventListener('input', function () {
            //show the clear
            handleSearchInput(this);

            //show results.
            const searchValue = this.value.toLowerCase();
            const divs = dropdownOptions.querySelectorAll('div');

            divs.forEach(div => {
                const textContent = div.innerText.toLowerCase();


                if (textContent.includes(searchValue)) {
                    div.style.display = 'flex';
                } else {
                    div.style.display = 'none';
                }
            });
        });

        dropdownOptions.addEventListener('click', function () {
            // Clear search result when dropdown options are reopened
            searchBox.value = '';
            originalOptions.forEach(div => {
                div.style.display = 'flex';
            });
        });

        document.body.addEventListener('click', function (event) {
            // Clear search box if clicked outside the dropdown
            if (!container.contains(event.target)) {
                searchBox.value = '';
                originalOptions.forEach(div => {
                    div.style.display = 'flex';
                });

                //also hide the clear "X" button.
                const clearResultsButton = searchBox.parentElement.querySelector('.clear-button');
                clearResultsButton.style.removeProperty('display');

            }
        });

        const clearbtn = container.querySelector('.clear-button');
        clearbtn.addEventListener('click', function () {
            clearDropdownSearch(this);
        });

        //mobile device handling (for fake form submissions.)
        // Event listener for form submission
        searchBox.addEventListener('search', function (event) {
            event.preventDefault();
            event.stopPropagation();
            // Prevent the default form submission behavior

            //alert("submitmobi search");
            // Clear the focus from the input to hide the virtual keyboard on mobile
            searchBox.blur();
        });

        // Event listener for Enter key on iOS
        searchBox.addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
                event.preventDefault(); // Prevent the default form submission behavior
                event.stopPropagation(); // Prevent the event from propagating up the DOM tree

                // Your search logic here, if needed
                // ...
                // Clear the focus from the input to hide the virtual keyboard on mobile
                searchBox.blur();
            }
        });

        //END OF CONTAINER:
    });

    //"X" CLEAR function.
    function clearDropdownSearch(clearButton) {
        const dropdownContainer = clearButton.closest('.acc-custom-selector__select--dropdown-options');

        const searchBox = dropdownContainer.querySelector('.bundle-search-box');

        const dropdownOptions = dropdownContainer.querySelector('.acc-custom-selector__select--dropdown-options-body');
        const originalOptions = Array.from(dropdownOptions.children);

        // Clear search result when closing dropdown
        originalOptions.forEach(div => {
            searchBox.value = '';
            div.style.display = 'flex';
        });

        //only for clear role: hide the button.
        //clearButton.style.setProperty ("display", "flex", "important"); 
        clearButton.style.removeProperty('display');

        // Hide the dropdown container
        //  dropdownContainer.classList.remove('show-dropdown');
    }

    //function for only displaying clear "X" when input gone...
    function handleSearchInput(searchBox) {
        const clearResultsButton = searchBox.parentElement.querySelector('.clear-button');
        const searchValue = searchBox.value.trim();

        if (searchValue !== '') {
            clearResultsButton.style.setProperty("display", "flex", "important");
        } else {
            //back to initial display "none"
            //clearResultsButton.style.removeAttribute('display');
            clearResultsButton.style.removeProperty('display');

        }


    }



  
});

